<template>
  <bkf-action
    :tooltip="$trans(tooltip)"
    @click="$emit('click')"
  >
    <v-icon>
      add
    </v-icon>
  </bkf-action>
</template>

<script>
export default {
  props: {
    tooltip: {
      required: false,
      type: String,
      default: 'v2.i2m_components.actions.add',
    },
  },
};
</script>
